(function () {
    'use strict';
    angular.module('app').directive('notificationReply', NotificationReplyDirective);
    
    NotificationReplyDirective.$inject = ['$document'];
    function NotificationReplyDirective($document) {
        return {
            templateUrl: '@/notifications/notification-reply.html',
            controllerAs: '$ctrl',
            controller: NotificationReplyController,
            link: function NotificationReplyLink(scope, element, _attributes, controller) {
                scope.$watch("notificationForReply", function (newValue) {
                    if (newValue) {
                        element[0].classList.add('visible');
                        $document.on('keydown', handleKey);
                    }
                    else {
                        element[0].classList.remove('visible');
                        // Destroy event listeners
                        $document.off('keydown', handleKey);
                    }
                });
       
                function handleKey(keyEvent) {
                    if (keyEvent.key === "Escape") {
                        controller.Close();
                        scope.$apply();
                    }
                }
            }
        };
    }

    NotificationReplyController.$inject = ['$scope', '$rootScope', '$document', 'notificationReplyService', 'webApiServices', 'notificationService', 'base64Service'];
    function NotificationReplyController($scope, $rootScope, $document, notificationReplyService, webApiServices, notificationService, base64Service) {
        const mainSelector = '#reply-dialog';
        const getTextAreaElement = () => $document[0].querySelector(`${mainSelector} div[class~='se-wrapper-inner']`);
        const getFileUploaderElement = () => $document[0].querySelector('#replyFileUploader');
        const $controller = this;

        $controller.$onInit = initialize;
        $controller.Close = closeReplyDiv;
        $controller.Open = notificationService.Open;
        $controller.SendReply = sendReply;
        $controller.DeleteAttachment = deleteAttachment;
        $controller.ShowReplyFileUploader = () => getFileUploaderElement().click();

        $scope.AddAttachment = addAttachment;

        function initialize() {
            notificationReplyService.subscribe((o) => openReplyDiv(o));
        }

        function openReplyDiv(notification) {
            $scope.notificationForReply = notification;
            $scope.reply = { Id: notification.Id, Type: notification.Type };
        }

        function closeReplyDiv() {
            console.log("NotificationReply::Close");
            $scope.notificationForReply = null;
        }

        function sendReply() {
            const text = getTextAreaElement().innerHTML;
            if (!text)
                return;

            $scope.reply.Message = text;

            webApiServices.ReplyOnNotification($scope.reply, handleSuccess, (err) => DoShowError(notificationService, err));
        }

        function handleSuccess(res) {
            if (res) 
                notificationService.success($rootScope.translations.Notification_Reply_Success);

            getTextAreaElement().innerHTML = '';
            closeReplyDiv();
        }

        function addAttachment(ele) {
            readFile(ele, (a) => {
                if (!$scope.reply.ReplyAttachments) $scope.reply.ReplyAttachments = [];
                $scope.reply.ReplyAttachments.push(a);
            });
        }

        function readFile(fileInput, callback) {
            if (!(fileInput.files instanceof FileList))
                return;
            if (fileInput.files.length === 0)
                return;

            Array.from(fileInput.files).forEach(file => {
                const reader = new FileReader();
                reader.onload = function () {
                    const content = base64Service.convertArrayBufferToBase64String(reader.result);
                    const name = file.name;
                    const attachment = { Name: name, Content: content, TypeCode: '150', Uploaded: new Date(), PublicId: $rootScope.guid.new() };
                    callback(attachment);
                    $scope.$apply();
                };
                reader.readAsArrayBuffer(file);
            });
        }

        function deleteAttachment(attachmentIndex) {
            if (attachmentIndex < 0)
                return;

            $scope.reply.ReplyAttachments.splice(attachmentIndex, 1);
        }
    }
})();